import { LayoutType } from 'src/app/core';
import { LayoutConfigBuilder } from 'src/app/layouts/default-layout/builders/layout-config.builder';
import { LayoutConfigPresets } from 'src/app/layouts/default-layout/models/layout-structures.models';

export enum TrainingSelfAttendanceRoutesConfig {
	BASE_URL = 'training-self-attendance',
	QRCODE = `${TrainingSelfAttendanceRoutesConfig.BASE_URL}/:qrcode`
}

const trainingSelfAttendancePageLayoutConfig = new LayoutConfigBuilder(LayoutConfigPresets.default)
	.setBodyCssClasses(['bg--white'])
	.setContentCssClasses(['wrap--no-scroll', 'wrap--no-padding'])
	.showDefaultSubHeader(false)
	.showDefaultFooter(false)
	.build();

export const trainingSelfAttendancePageData = {
	layout: LayoutType.LARGE,
	layoutConfig: trainingSelfAttendancePageLayoutConfig
};
